import React from 'react';
import Link from 'router/Link';
import { Box, Icon } from '@spothero/ui';
import IconSpothero from '@spothero/icons/spothero';
export const CompanyLogo = ({ isWhiteHeader }) => {
    return (<Box as="h1" display="flex">
            <Link to="/" forceAnchor aria-label="Home" data-testid="Header-logo" className="CompanyLogo">
                <Icon alt="SpotHero" aria-hidden="true" as={IconSpothero} position="absolute" top="50%" transform="translate(0, -50%)" left={{ base: '4', tablet: '2.5' }} width="14" height="14" fill={isWhiteHeader ? 'primary.default' : 'white'}/>
            </Link>
        </Box>);
};
